import regionQuery from "./region";

const expertQuery = `*[_type == "expert"] | order(title asc)
{   
    description,
    email,
    phone,
    title,
    ${regionQuery}
}
`;

export default expertQuery;
